import { __decorate } from "tslib";
import { Component, Mixins } from 'vue-property-decorator';
import OperatingHours from '@/plugins/graphql/queries/v2/operating-hour.gql';
import LeadTime from '@/plugins/graphql/queries/v2/lead-time.gql';
import UpdateOperatingAndLeadTime from '@/plugins/graphql/mutations/v2/update-operating-and-lead-time.gql';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
let OperatingLeadTimeMixin = class OperatingLeadTimeMixin extends Mixins(RouterParamsAppMixin) {
    async updateOperatingAndLeadTime(form) {
        const mutation = await this.$apollo.mutate({
            mutation: UpdateOperatingAndLeadTime,
            variables: {
                input: {
                    appUuid: form.appUuid,
                    enableLeadTime: form.enableLeadTime,
                    enableOperatingHour: form.enableOperatingHours,
                    leadTimeValue: form.leadTimeValue,
                    openingHour: this.convertToMilitaryTime(form.openingHour),
                    closingHour: this.convertToMilitaryTime(form.closingHour),
                    allowClosingHoursOrder: form.allowClosingHoursOrder,
                },
            },
        });
        await this.$apollo.queries.operatingHours.refetch();
        await this.$apollo.queries.leadTime.refetch();
        return mutation;
    }
    convertToMilitaryTime(time12) {
        if (!time12)
            return '';
        const [time, period] = time12.split(' ');
        const [hours, minutes] = time.split(':');
        let hour24 = parseInt(hours, 10);
        if (period === 'AM') {
            if (hour24 === 12) {
                hour24 = 0; // Midnight
            }
        }
        else if (period === 'PM') {
            if (hour24 !== 12) {
                hour24 += 12; // Convert PM hours to military time
            }
        }
        // Ensure two-digit formatting for hours and minutes
        const hourFormatted = hour24.toString().padStart(2, '0');
        const minuteFormatted = minutes.padStart(2, '0');
        return `${hourFormatted}:${minuteFormatted}`;
    }
    get getOperatingHours() {
        return this.operatingHours;
    }
    get getLeadTime() {
        return this.leadTime;
    }
    formatTime(time24) {
        if (!time24)
            return '';
        const [hours, minutes] = time24.split(':');
        const hour = parseInt(hours, 10);
        let period = 'AM';
        let hour12 = hour;
        if (hour === 0) {
            hour12 = 12;
        }
        else if (hour === 12) {
            period = 'PM';
        }
        else if (hour > 12) {
            hour12 = hour - 12;
            period = 'PM';
        }
        return `${hour12}:${minutes} ${period}`;
    }
};
OperatingLeadTimeMixin = __decorate([
    Component({
        apollo: {
            operatingHours: {
                query: OperatingHours,
                variables() {
                    return {
                        appUuid: this.appUUID,
                    };
                },
                update(data) {
                    const operatingHour = data.fetchOperatingHour;
                    return operatingHour;
                },
                fetchPolicy: 'network-only',
            },
            leadTime: {
                query: LeadTime,
                variables() {
                    return {
                        appUuid: this.appUUID,
                    };
                },
                update(data) {
                    const leadTime = data.fetchLeadTime;
                    return leadTime;
                },
                fetchPolicy: 'network-only',
            },
        },
    })
], OperatingLeadTimeMixin);
export default OperatingLeadTimeMixin;
